module.exports = __webpack_public_path__ + "static/media/curriculum_s4.f08da205.png";